import { forwardRef } from 'react';
import { Box } from '@mui/material';

import { isProd } from '../../utils/config';

interface LogoProps {
	isCollapsed?: boolean;
}

const Logo = forwardRef<HTMLImageElement, LogoProps>(({ isCollapsed = false }, ref) => {
	let src = isProd ? '/assets/ausrehab-logo.png' : '/assets/ausrehab-logo-dev.png';

	if (isCollapsed) {
		src = '/favicon/favicon-32x32.png';
	}

	const logo = (
		<Box
			component="img"
			ref={ref}
			alt="ausrehab"
			src={src}
			sx={{
				width: isCollapsed ? 44 : 239,
				height: 'auto',
				maxWidth: '100%',
				overflow: 'hidden',
			}}
		/>
	);

	return <>{logo}</>;
});

export default Logo;
